import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'app/environments/environment';
import { OrganizationUser } from 'app/core/interfaces/organizationUser';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationSubUsersService {
  constructor(private http: HttpClient) {}

  public createSubUser(params: OrganizationUser): Observable<OrganizationUser> {
    return this.http.post<OrganizationUser>(`${environment.apiUrl}/secretarias-organization-sub-users`, params);
  }

  public updateSubUser(subUserId: string | undefined, params: OrganizationUser) {
    return this.http.put(`${environment.apiUrl}/secretarias-organization-sub-users/${subUserId}`, params);
  }

  public showSubUser(subUserId: string) {
    return this.http.get<OrganizationUser>(`${environment.apiUrl}/secretarias-organization-sub-users/${subUserId}`);
  }

  public list() {
    return this.http.get(`${environment.apiUrl}/secretarias-organization-sub-users`);
  }

  public deleteSubUser(subUserId: string) {
    return this.http.delete(`${environment.apiUrl}/secretarias-organization-sub-users/${subUserId}`);
  }

  public activeSubUser(subUserId: string) {
    return this.http.delete(`${environment.apiUrl}/secretarias-organization-sub-users/${subUserId}`);
  }

  public getOrganizationSubUsers(organization_id: string) {
    return this.http.get<OrganizationUser>(`${environment.apiUrl}/secretarias-organization-sub-users/getUsersByOrganization/${organization_id}`);
  }

  public getSubUserBySub(user_sub: string) {
    return this.http.get<OrganizationUser>(`${environment.apiUrl}/secretarias-organization-sub-users/getUserBySub/${user_sub}`);
  }
}
